import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { User, Phone, Mail } from "lucide-react";
import { committeePhotoUrl } from "@/lib/api";

export default function CommitteeSection({ members = [] }) {
  const { t, lang } = useLang();
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";
  const fontB = lang === "ta" ? "font-sans-ta" : "";

  return (
    <section id="committee" data-testid="committee-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.3em] text-amber-700">إدارة · Idarah</span>
          <h2 data-testid="committee-heading" className={`${fontH} text-4xl md:text-5xl text-emerald-950 mt-2`}>
            {t("committee_heading")}
          </h2>
          <p className={`mt-3 text-stone-500 ${fontB}`}>{t("committee_subhead")}</p>
        </div>

        {members.length === 0 ? (
          <div className="text-center text-stone-500">{t("no_committee")}</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {members.map((m, i) => {
              const name = lang === "ta" && m.name_ta ? m.name_ta : m.name_en;
              const role = lang === "ta" && m.designation_ta ? m.designation_ta : m.designation_en;
              return (
                <article key={m.id} data-testid={`committee-member-${i}`} className="mosque-card p-6 flex flex-col">
                  <div className="flex items-start gap-4">
                    {m.photo_path ? (
                      <img
                        src={committeePhotoUrl(m.id)}
                        alt={name}
                        className="w-14 h-14 rounded-full object-cover ring-2 ring-emerald-900/15 shrink-0"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-full bg-emerald-900 grid place-items-center text-amber-300 shrink-0">
                        <User className="w-6 h-6" />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <h3 className={`${fontH} text-xl text-emerald-950 leading-tight`}>{name}</h3>
                      <div className="text-xs uppercase tracking-widest text-amber-700 mt-1">{role}</div>
                    </div>
                  </div>
                  <div className="mt-5 space-y-2 text-sm">
                    {m.phone && (
                      <a href={`tel:${m.phone}`} className="flex items-center gap-2 text-stone-700 hover:text-emerald-900 transition-colors">
                        <Phone className="w-3.5 h-3.5 text-emerald-900" /> {m.phone}
                      </a>
                    )}
                    {m.email && (
                      <a href={`mailto:${m.email}`} className="flex items-center gap-2 text-stone-700 hover:text-emerald-900 transition-colors truncate">
                        <Mail className="w-3.5 h-3.5 text-emerald-900" /> {m.email}
                      </a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
